import React, { useState, useEffect } from 'react';
import "../AddClients/tableStyle.css"
import {  getLifterPaymentByDoId } from '../../Services/Services';
import Header from '../Header-Footer/Header';
import Footer from '../Header-Footer/Footer';
import { Link,useParams } from 'react-router-dom';
export default function LifterPayViewByDo() {
  const [payList, setPayList] = useState([])
  const { id } = useParams()
  useEffect(() => {
    Get_Pay_Details()
  }, [])
  const Get_Pay_Details = async () => {
    const response = await getLifterPaymentByDoId({'com_name':localStorage.getItem('com_name'),'do_id':id})
    if (response) {
      setPayList(response);
    }
  };
  
  return (
    <div>
      <Header heading="LIFTER PAYMENT VIEW" />
  <br/>
      <div className="table-container"  >
        <table id="my-table" className="w-full relative">
          <thead className="bg-[#151B54] w-full text-white">
            <tr>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">Sr. No</th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">Lifter Name</th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">Do No</th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">Amount</th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">Date</th>
            </tr>
          </thead>
          <tbody>

            {payList.map((e, index) => (

              <tr key={e.index} style={{ backgroundColor: e.rem_qty === 0 ? '#b8ebb8' : '' }}>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">{index + 1}</td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">{e.lifter_name}</td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  <Link to={`/do-view/${e.do_id}`}><u style={{ fontWeight: '600', color: 'blue' }}>
                    {e.do_no}
                  </u></Link>
                </td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">{e.pay_amount}</td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">{e.date}</td>

              </tr>
            ))}
            <tr style={{ backgroundColor: '#e9e9e9' }}>
              <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base" colSpan={3}><b>Total</b></td>
              <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                <b>{payList.reduce(
                  (accumulator, currentValue) =>
                    accumulator + (+currentValue.pay_amount),
                  0
                ).toFixed(2)}</b></td>


              <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base"></td>
            </tr>
          </tbody>
        </table>
      </div>
      <Footer/>
    </div>
  )
}
